export const CloseIcon = ({ color }) => (
  <svg viewBox="0 0 10 10" width={11} stroke={color ? color : "#000000"} strokeWidth="1px">
    <path d="M1,1 L10,10" />
    <path d="M10,1 L1,10" />
  </svg>
);